export default "__VITE_ASSET__89dc49f0__"